import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import api from "@/api";

const AuthCallback = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const sessionId = location.hash.split("session_id=")[1]?.split("&")[0];
    if (!sessionId) {
      navigate("/", { replace: true });
      return;
    }
    api
      .post("/auth/google/session", { session_id: sessionId })
      .then(({ data }) => navigate("/", { state: { user: data }, replace: true }))
      .catch(() => navigate("/", { replace: true }));
  }, [location, navigate]);

  return (
    <div className="min-h-screen bg-forest text-cream flex items-center justify-center" data-testid="auth-callback">
      <div className="text-center">
        <img src="/logo.png" alt="Chai Times" className="w-20 h-20 mx-auto mb-6 rounded-full animate-pulse" />
        <p className="font-mono text-xs uppercase tracking-[0.25em] text-gold">Pouring you in…</p>
      </div>
    </div>
  );
};

export default AuthCallback;
